import { render, staticRenderFns } from "./ProductBreadcrumb.vue?vue&type=template&id=3824cc00"
import script from "./ProductBreadcrumb.vue?vue&type=script&lang=js"
export * from "./ProductBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports